import API from "./api"

export default function useTopicRecordBulk() {
  const url = "/topics/records/bulk"

  async function destroy({ ids }) {
    await API.delete(url, { ids })
  }

  return { destroy }
}
